import axios from 'axios';

document.addEventListener('DOMContentLoaded', () => {
  const getMe = () => axios.get('/api/qb/v1/users/me')
    .then(response => response.data)
    .catch(error => Rollbar.error('manualTrackingParamsGetMe', error));

  const triggerDataLayerVisit = (params) => {
    dataLayer.push({
      ...params,
      event: 'New Manual Visit',
      impersonated: QB.impersonated,
    });
  };

  const triggerDataLayerQueryString = () => {
    const queryString = Object.fromEntries(new URLSearchParams(window.location.search));
    /* eslint-disable camelcase */
    const {
      utm_medium = '',
      utm_source = '',
      utm_campaign = '',
      utm_term = '',
      utm_content = '',
      gclid = '',
      partner_id = '',
      p = '',
      partner_custom_data = '',
      zanpid = '',
      cipher = '',
      conectado = '',
    } = queryString;

    const queryStringData = {
      utm_medium,
      utm_source,
      utm_campaign,
      utm_term,
      utm_content,
      gclid,
      partner_id: partner_id || p,
      partner_custom_data,
      zanpid,
      cipher,
      conectado,
    };

    dataLayer.push(queryStringData);
  };

  const triggerDataLayerRequestData = ({ ip, referrer, user_agent }) => {
    dataLayer.push({ ip, referrer, user_agent });
  };

  const getCityStateFromQuery = () => {
    const match = document.location.search.match(/city_state=([^-]+)\+-\+([^&]+)/i);

    if (!match) return null;

    return match.slice(1, 3).map(e => decodeURIComponent(e).replace(/\+/g, ' '));
  };

  const refreshCitySelector = ({
    search_city,
    search_state,
    search_lat,
    search_lng,
  }) => {
    if (!search_city || !search_state || (search_city === 'São Paulo' && search_state === 'SP')) return;

    window.QB = window.QB || {};

    window.QB.skipFinancialAidSpinner = true;

    // Precisa ter esses requires aqui para garantir que o código de inicialização em outro arquivo será executado
    _require([
      'jquery/select2',
      'jquery/select2v3',
      'jquery_visible',
      'jquery/dataTables',
    ], () => {
      setTimeout(() => {
        $('.js-grades-form #interest_city')
          .append(new Option(`${search_city} - ${search_state}`, search_city, false, false))
          .val(search_city)
          .trigger('change')
          .trigger({
            type: 'select2:select',
            params: {
              data: {
                state: search_state,
                city: search_city,
                lat: search_lat,
                lng: search_lng,
                selected: true,
              },
            },
          });
      });
    });
  };

  $(async () => {
    const cityState = getCityStateFromQuery();
    const user = await getMe();

    if (cityState) {
      refreshCitySelector({
        search_city: cityState[0],
        search_state: cityState[1],
      });
    } else {
      refreshCitySelector(user);
    }

    triggerDataLayerQueryString();
    triggerDataLayerRequestData(user);

    // set variables removed from default js_server_vars
    QB.userId = user.id;
    QB.isUserSignedIn = !user.is_pre_user;
    QB.impersonated = user.is_impersonated;
    QB.userHasFbLogin = !!user.fb_uid;
    QB.amplitudeParams = user;

    triggerDataLayerVisit(QB.manualTrackingParams);

    _require(['metrics'], () => {
      if (!QB.isTestEnv) {
        trackable.trackCurrentUser();
      }
    });
  });
});
